import { render } from "./PaymentSuccessView.vue?vue&type=template&id=27904464&ts=true"
import script from "./PaymentSuccessView.vue?vue&type=script&lang=ts"
export * from "./PaymentSuccessView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__